import React, {Component} from "react";
import PropTypes from "prop-types";

class SimpleCheckBox extends Component {
    getStyles = () => {
        const { disabled } = this.props;

        return {
            container: {
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
            },
            input: {
                cursor: disabled ? 'not-allowed' : 'pointer',
                width: '20px',
                height: '20px',
            },
            label: {
                fontSize: '16px',
                cursor: disabled ? 'not-allowed' : 'pointer',
                color: disabled ? 'gray' : 'inherit',
            },
        };
    };

    render() {
        const { id, label, name, checked, onChange, disabled } = this.props;
        const styles = this.getStyles();

        return (
            <div style={{...styles.container, ...this.props.styles}}>
                <input
                    type="checkbox"
                    id={id}
                    name={name}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    style={styles.input}
                />
                {label && (
                    <label htmlFor={id} style={styles.label}>
                        {label}
                    </label>
                )}
            </div>
        );
    }
}

SimpleCheckBox.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

// Default props
SimpleCheckBox.defaultProps = {
    label: '',
    checked: false,
    disabled: false,
};

export default SimpleCheckBox;